/**
 * Languages supported across the product: the mobile app ships UI translations
 * (mobile/src/text/<lang>.ts) and the API ships push/feed translations
 * (backend/apps/api/i18n/locales/<lang>) for every entry. Keep both in sync
 * when adding a language. A language may ship empty translation files while
 * translation is in progress — every missing key falls back to en.
 */
export const APP_LANGUAGES = ['en', 'es', 'pt', 'fr'] as const;
export type AppLanguage = (typeof APP_LANGUAGES)[number];

/**
 * Fallback for any text missing in a user's language — mobile i18next, the API's
 * nestjs-i18n, and push text resolution all fall back to it.
 */
export const DEFAULT_LANGUAGE: AppLanguage = 'en';
